var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1c8.285 0 15 6.715 15 15s-6.715 15-15 15S1 24.285 1 16 7.715 1 16 1zm8.25 8.97-1.669 2.597a7.345 7.345 0 0 1 .804 3.37 7.44 7.44 0 0 1-7.447 7.447 7.27 7.27 0 0 1-3.353-.803L9.97 24.267c1.685 1.196 3.731 1.92 5.951 1.92 5.653 0 10.25-4.58 10.25-10.249a10.143 10.143 0 0 0-1.722-5.683l-.198-.284zm-8.313-4.283a10.24 10.24 0 0 0-10.25 10.25c0 2.283.741 4.377 2 6.077a12.087 12.087 0 0 1 1.748-2.41s1.007-1.053 1.78-1.588a12.226 12.226 0 0 1 7.241-2.363c.748 0 1.474.066 2.187.197l.427.087a5.15 5.15 0 0 0-5.149-5.149 5.138 5.138 0 0 0-5.11 5.61l.026.232c-1.29.992-1.905 1.763-1.937 1.794a7.442 7.442 0 0 1 7.022-9.919c1.211 0 2.345.284 3.353.804l2.597-1.686a9.992 9.992 0 0 0-5.935-1.937zm2.582 10.895c-2.55 0-4.928.82-6.85 2.205a5.117 5.117 0 0 0 4.266 2.267 5.14 5.14 0 0 0 5.055-4.204 11.656 11.656 0 0 0-2.47-.268z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZen);
export default __webpack_public_path__ + "static/media/ZEN.23de40c92aa68a0c3cdea3b51fdff746.svg";
export { ForwardRef as ReactComponent };